const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: [
            "At Sunspot Solar Energy, we value your privacy and are committed to safeguarding the information you share with us.",
            "This Privacy Policy explains how we collect, use, and protect your personal and usage data when you interact with our website and solar energy solutions.",
            "By using our services, you acknowledge and agree to the terms of this Privacy Policy."
        ]
    },
    {
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: [
            "We collect personal and non-personal data to enhance your experience and deliver customized solar energy solutions.",
            "The data we collect may include, but is not limited to:"
        ],
        list: [
            "Customer contact and account registration details",
            "Information about your property for solar assessment",
            "Billing, payment, and installation records",
            "Customer support interactions and feedback"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: [
            "Our Terms of Service govern the use of the Sunspot platform and its solar energy products and services.",
            "By accessing our website or engaging our services, you agree to follow these terms, which outline permitted use, service limitations, and user responsibilities."
        ]
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: [
            "As our customer, you have rights concerning your personal information, including:"
        ],
        list: [
            "Right to access, update, or request deletion of your personal data",
            "Right to withdraw consent for data processing at any time",
            "Right to request corrections to inaccurate or incomplete information"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: [
            "We use industry-standard security measures to protect your data from unauthorized access, misuse, or disclosure.",
            "Your information is safeguarded through advanced encryption, secure servers, and strict access controls."
        ]
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: [
            "Sunspot uses cookies and similar tracking technologies to improve user experience and analyze website performance.",
            "Cookies help us optimize system performance, tailor recommendations, and provide content relevant to your interests."
        ]
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: [
            "We work with trusted third-party partners, such as financing institutions, installation contractors, and hosting providers, to deliver our solar energy services.",
            "These partners process your data under their own privacy policies. We recommend reviewing their policies for further details."
        ]
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: [
            "Your data is securely stored on servers protected with advanced security protocols.",
            "We retain data for as long as needed to provide our services or comply with legal obligations. You may request data removal or transfer at any time."
        ]
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: [
            "Your data may be processed in locations outside your country of residence.",
            "All transfers comply with relevant data protection laws to ensure your information remains safe."
        ]
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: [
            "Sunspot may update this Privacy Policy to reflect changes in our services, technology, or legal requirements.",
            "We will notify you of significant updates and always provide the latest version on our website."
        ]
    }
];

export default privacyPolicy;